import React from "react";
import { useLocation } from "react-router-dom";
import moment from "moment";

const Footer: React.FC = () => {
  const location = useLocation();
  const isAdminDashboard = location.pathname === "/index";

  return (
    <footer
      id="footer"
      className={isAdminDashboard ? "dash-footer" : "sticky-footer"}
    >
      <div className="footer d-flex align-items-center justify-content-center border-top bg-white p-2 w-100">
        <div
          className="text-center"
          style={{ display: "flex", flexWrap: "wrap" }}
        >
          <span>Powered by Log Binary</span>
          <span className="mx-2">|</span>
          <span>
            <a href="http://logbinary.com"> Copyright © {moment().year()} </a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
